import { defineComponent, ref, toRefs, computed } from 'vue-demi';
import './TimeFormat-a7f5565b.js';
import './dom-53c9635b.js';
import { i as isEmpty } from './isString-cf957a95.js';
import { i as isEqual } from './isEqual-15f4b2f5.js';
import '@vueuse/core';
import { u as useProxyModelValue } from './useProxyModelValue-e18f251e.js';
import '@onereach/styles/screens.json';
import '@onereach/styles/tailwind.config.json';
import { s as script$2 } from './OrSelectControlInput-e0116b29.js';
import { s as script$1 } from './OrSelectPlaceholder-81502228.js';
import { resolveComponent, openBlock, createElementBlock, normalizeClass, createBlock, Fragment, withCtx, createTextVNode, toDisplayString } from 'vue';

const SelectSingleControlInput = [
// Layout
'w-full'];

var script = defineComponent({
  name: 'OrSelectSingleControl',
  components: {
    OrSelectPlaceholder: script$1,
    OrSelectControlInput: script$2
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    model: {
      type: undefined,
      default: undefined
    },
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    enableSearch: {
      type: Boolean,
      default: false
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  expose: ['root', 'focus', 'focused'],
  setup(props, context) {
    // Refs
    const root = ref();
    const searchControl = ref();
    // Props
    const {
      modelValue,
      model,
      options
    } = toRefs(props);
    // State
    const searchModelValue = useProxyModelValue(modelValue, context.emit);
    const isEmptyModelValue = computed(() => {
      return isEmpty(model.value);
    });
    const selection = computed(() => {
      return options.value.find(option => isEqual(option.value, model.value));
    });
    const selectionLabel = computed(() => {
      var _a;
      return (_a = selection.value) === null || _a === void 0 ? void 0 : _a.label;
    });
    const focused = computed(() => {
      var _a;
      return (_a = searchControl.value) === null || _a === void 0 ? void 0 : _a.focused;
    });
    // Styles
    const rootStyles = computed(() => ['or-select-single-control-v3', ...SelectSingleControlInput]);
    // Methods
    function focus() {
      if (searchControl.value) {
        searchControl.value.focus();
      }
    }
    return {
      root,
      rootStyles,
      searchControl,
      searchModelValue,
      isEmptyModelValue,
      selection,
      selectionLabel,
      focus,
      focused
    };
  }
});

const _hoisted_1 = {
  key: 1,
  class: "truncate"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrSelectControlInput = resolveComponent("OrSelectControlInput");
  const _component_OrSelectPlaceholder = resolveComponent("OrSelectPlaceholder");
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles)
  }, [_ctx.isOpen && _ctx.enableSearch ? (openBlock(), createBlock(_component_OrSelectControlInput, {
    key: 0,
    ref: 'searchControl',
    modelValue: _ctx.searchModelValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.searchModelValue = $event),
    placeholder: _ctx.isEmptyModelValue ? _ctx.placeholder : _ctx.selectionLabel
  }, null, 8 /* PROPS */, ["modelValue", "placeholder"])) : (openBlock(), createElementBlock(Fragment, {
    key: 1
  }, [_ctx.isEmptyModelValue ? (openBlock(), createBlock(_component_OrSelectPlaceholder, {
    key: 0,
    disabled: _ctx.disabled
  }, {
    default: withCtx(() => [createTextVNode(toDisplayString(_ctx.placeholder), 1 /* TEXT */)]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["disabled"])) : (openBlock(), createElementBlock("span", _hoisted_1, toDisplayString(_ctx.selectionLabel), 1 /* TEXT */))], 64 /* STABLE_FRAGMENT */))], 2 /* CLASS */);
}

script.render = render;
script.__file = "src/components/or-select-v3/partials/or-select-single-control/OrSelectSingleControl.vue";

export { script as s };
